<template>
    <div>
        <campaign-information-modal
            :campaign="campaign"
            :name="campaignModalName"
            :isPreview="isPreview"
        ></campaign-information-modal>

        <div
            class="bg-white dark:bg-slate-800 h-full mx-auto text-center pb-4 flex flex-col justify-left max-w-lg"
            v-bind:class="{'shadow': !grouped}"
        >
            <img :src="campaign.image" :alt="campaign.name" class="mb-4">

            <h4 class="text-base font-bold text-center mx-2 mb-2 dark:text-slate-200">
                {{ campaign.name }}
            </h4>

            <p class="flex-grow text-center text-sm mx-2 leading-normal mb-4 dark:text-gray-100" v-html="campaign.description.slice(0, 120) + (campaign.description.length > 120 ? '...' : '')"></p>

            <div class="flex px-4 justify-end flex-grow flex-col self-end w-full">

                <a
                    v-if="hasDiscountCode"
                    class="btn btn-primary btn-small mb-2 w-full"
                    @click.prevent="openCouponCodeModal"
                >
                    {{ _('campaigns.show_coupon_code') }}
                    <campaign-code-modal
                        :campaign="campaign"
                        :name="campaignCodeModalName"
                        :isPreview="isPreview"
                    ></campaign-code-modal>
                </a>
                <a
                    v-else-if="!sidePanel"
                    class="btn btn-primary btn-small mb-2 w-full"
                    @click.prevent="openCampaignInfoModal"
                >
                    {{ _('campaigns.to_campaign') }}
                </a>

            </div>
        </div>
    </div>
</template>

<script>

    import { mapGetters, mapMutations } from 'vuex'

    export default {
        props: {
            campaign: {
                required: true,
                type: Object,
            },
            gaName: {
                required: false,
            },
            openModalOnLoad: {
                required: false,
            },
            isPreview: {
                required: false,
            },
            grouped: {
                required: false,
                default: false
            },
            sidePanel: {
                default: false,
                required: false
            }
        },

        data() {
            return {
                store: this.campaign.store,
            }
        },

        mounted() {
            if(this.openModalOnLoad) {
                switch(this.openModalOnLoad) {
                    case 'code':
                        this.showModal(this.campaignCodeModalName);
                    break;
                    case 'info':
                        this.showModal(this.campaignModalName);
                    break;
                }
            }
        },

        computed: {
            ...mapGetters('general', ['_', 'isSv', 'loggedIn', 'redirectUrl', 'getPath', 'user', 'env']),

            clickUrl() {
                return '/click/landing/store/' + this.store.store_id;
            },

            campaignModalName() {
                return "campaign-" + this.campaign.campaign_id;
            },

            campaignCodeModalName() {
                return "campaign-code-" + this.campaign.campaign_id;
            },

            storeLogo() {
                if(this.store.logo) {
                    return 'stores/logos/' + this.store.logo;
                }

                return 'stores/' + this.store.image;
            },

            hasDiscountCode() {
                let campaignTypeDiscountPresent = this.campaign.types
                    ? !! this.campaign.types.find((type) => type.slug == 'discount_code')
                    : false;

                return campaignTypeDiscountPresent && (this.isPreview || this.campaign.discount_code
                    && this.campaign.discount_code_valid_to
                    && this.campaign.discount_code_valid_from
                    && new Date(this.campaign.discount_code_valid_to.replace(' ', 'T')) > new Date()
                    && new Date(this.campaign.discount_code_valid_from.replace(' ', 'T')) < new Date());
            },

            showCountdown() {
                // Don't show countdown for new stores
                return this.campaign.types
                    ? ! this.campaign.types.find((type) => type.slug == 'new_store')
                    : true;
            },

            strippedName() {
                return this.campaign.name.split(' ').join('_').toLowerCase();
            }
        },

        methods: {
            ...mapMutations('general', ['setRedirectUrl']),
            ...mapMutations('modal', ['showModal', 'hideModal']),

            openCouponCodeModal() {
                this.trackClick();

                if(this.loggedIn) {
                    return this.showModal(this.campaignCodeModalName);
                }

                this.setRedirectUrl(this.$url.setQueryParam('show_modal', this.campaignCodeModalName));

                return this.showModal('login-to-continue-modal');
            },

            openCampaignInfoModal() {
                this.trackClick();

                if( this.loggedIn) {
                    return this.showModal(this.campaignModalName);
                }

                this.setRedirectUrl(this.$url.setQueryParam('show_modal', this.campaignModalName));

                return this.showModal('login-to-continue-modal');
            },

            trackClick() {
                if(this.env == 'production') {
                    // GA was here. Implement something else?
                }
            }
        },
    }

</script>
